import { PayloadAction } from '@reduxjs/toolkit';
import { jobCardState } from '.';
import { jobCarReportAdapter, jobCardAdapter } from './adapter';
import { IJobCardV2 } from '../../types/models/jobCard';
import { IJobCardReport } from '~/types/models/jobCardReport';
import { ITimeReport } from '~/types/models/timeReport';
import { IUpdateEntity } from '../types';

enum loaders {
  loadingTimeReports = 'loadingTimeReports',
  isLoadingCreateReport = 'isLoadingCreateReport',
}

const jobCardReducer = {
  selectJobCard: (state: jobCardState, action: PayloadAction<IJobCardV2 | null>) => {
    state.selectedJobCard = action.payload;
  },

  updateOneJobCardReport: (state: jobCardState, action: PayloadAction<IUpdateEntity<IJobCardReport>>) => {
    jobCarReportAdapter.updateOne(state.jobCardReports, action.payload);
  },

  updateManyJobCardReport: (state: jobCardState, action: PayloadAction<IUpdateEntity<IJobCardReport>[]>) => {
    jobCarReportAdapter.updateMany(state.jobCardReports, action.payload);
  },

  setJobCardFilter: (state: jobCardState, action: PayloadAction<Record<string, any>>) => {
    state.filter = {
      ...action.payload,
    };
  },

  clearJobCardFilter: (state: jobCardState) => {
    state.filter = undefined;
  },

  clearJobCardsRunning: (state: jobCardState) => {
    jobCardAdapter.removeAll(state.jobCardsRunning);
    state.jobCardsRunning.pagination = {
      page: 1,
      count: 10,
      isMax: false,
      all: 0,
    };
  },

  clearJobCardsRecently: (state: jobCardState) => {
    jobCardAdapter.removeAll(state.jobCardsRecently);
    state.jobCardsRecently.pagination = {
      page: 1,
      count: 10,
      isMax: false,
      all: 0,
    };
  },

  clearJobCardsNotRunning: (state: jobCardState) => {
    jobCardAdapter.removeAll(state.jobCardsNotRunning);
    state.jobCardsNotRunning.pagination = {
      page: 1,
      count: 10,
      isMax: false,
      all: 0,
    };
  },

  clearJobCardReports: (state: jobCardState) => {
    jobCarReportAdapter.removeAll(state.jobCardReports);
  },

  clearSelectedJobCard: (state: jobCardState) => {
    state.selectedJobCard = null;
  },

  setShowReportSavedModal: (state: jobCardState, action: PayloadAction<boolean>) => {
    state.showReportSavedModal = action.payload;
  },

  setIsNeedAutoStartStop: (state: jobCardState, action: PayloadAction<boolean>) => {
    state.isNeedAutoStartStop = action.payload;
  },

  setIsSearching: (state: jobCardState, action: PayloadAction<boolean>) => {
    state.isSearching = action.payload;
  },

  resetShowReportSavedModal: (state: jobCardState) => {
    state.showReportSavedModal = false;
  },

  resetIsAddedReportWithEndTime: (state: jobCardState) => {
    state.isAddedReportWithEndTime = false;
  },

  toggleLoader: (state: jobCardState, action: PayloadAction<{ key: keyof typeof loaders; value: boolean }>) => {
    state[action.payload.key] = action.payload.value;
  },

  updateOneReportInJobCard: (
    state: jobCardState,
    action: PayloadAction<{ jobCardId: string; report: ITimeReport }>,
  ) => {
    const { jobCardId, report } = action.payload;

    let jobCard = jobCardAdapter.getSelectors().selectById(state.jobCardsNotRunning, jobCardId);

    if (!jobCard) {
      jobCard = jobCardAdapter.getSelectors().selectById(state.jobCardsRecently, jobCardId);
    }
    if (!jobCard) {
      jobCard = jobCardAdapter.getSelectors().selectById(state.jobCardsRunning, jobCardId);
    }

    const newReports = (jobCard?.Reports || []).map((item) => {
      if (item._id === report._id) {
        return {
          ...item,
          ...report,
        };
      } else {
        return item;
      }
    });

    const changes = {
      Reports: newReports,
    };

    jobCardAdapter.updateOne(state.jobCardsNotRunning, { id: jobCardId, changes: changes });
    jobCardAdapter.updateOne(state.jobCardsRunning, { id: jobCardId, changes: changes });
    jobCardAdapter.updateOne(state.jobCardsRecently, { id: jobCardId, changes: changes });
  },
};

export default jobCardReducer;
